import ListView from "../view/view-types/list.js";
import ButtonView from "../view/view-types/button.js";

import ViewTypesModel from "../model/view-types.js";

import {
  defaultViewTypesModelData,
  ActionType,
  VIEW_TYPE_KEY,
  ViewType
} from "../../const.js";

export default class ViewTypes {
  constructor(element, changeFilter, browserNavigation) {
    this._listView = new ListView(element);
    this._changeFilter = changeFilter;
    this._browserNavigation = browserNavigation;

    this._model = null;
    this._buttonsViews = [];

    this._handleButtonClick = this._handleButtonClick.bind(this);
    this._handleModelChange = this._handleModelChange.bind(this);
    this._handleBrowserNavigation = this._handleBrowserNavigation.bind(this);
  }

  init() {
    const buttons = this._listView.getButtons();
    const activeViewType = this._listView.getActiveType();

    Array.from(buttons).forEach((button) => {
      const buttonView = new ButtonView(button);
      buttonView.setClickHandler(this._handleButtonClick);
      this._buttonsViews.push(buttonView);
    });

    this._model = new ViewTypesModel(
        Object.assign(
            {},
            defaultViewTypesModelData,
            {
              activeViewType
            }
        )
    );
    this._model.addObserver(this._handleModelChange);

    this._browserNavigation.addObserver(this._handleBrowserNavigation);
  }

  _handleBrowserNavigation(params) {
    const modelData = this._model.getData();

    let type = params
      .filter((item) => {
        return item.name === VIEW_TYPE_KEY;
      })
      .map((item) => {
        return item.values.trim();
      })
      .join(``);

    if (type === ``) {
      type = ViewType.CARD;
    }

    if (type === modelData.activeViewType) {
      return;
    }

    this._model.changeData(Object.assign(
        {},
        modelData,
        {
          activeViewType: type
        }
    ), ActionType.BROWSER_NAVIGATE);
  }

  _handleButtonClick(type) {
    const modelData = this._model.getData();

    if (type === modelData.activeViewType) {
      return;
    }

    this._model.changeData(Object.assign(
        {},
        modelData,
        {
          activeViewType: type
        }
    ), ActionType.CHANGE_VIEW_TYPE);
  }

  _handleModelChange(action) {
    switch (action) {
      case ActionType.CHANGE_VIEW_TYPE:
        this._buttonsViews.forEach((buttonView) => {
          if (buttonView.getType() === this._model.getData().activeViewType) {
            buttonView.setActive();
          } else {
            buttonView.setDefault();
          }
        });

        this._changeFilter.updateProductsData({
          view: this._model.getData().activeViewType
        });
        break;
      case ActionType.BROWSER_NAVIGATE:
        this._buttonsViews.forEach((buttonView) => {
          if (buttonView.getType() === this._model.getData().activeViewType) {
            buttonView.setActive();
          } else {
            buttonView.setDefault();
          }
        });
        break;
    }
  }
}
